import get from 'lodash.get';
import { LABEL_SERVICE_BATCH_STATUS_IDS } from '../../constants/label-batch-status-ids';

export const checkLabelBatchIsComplete = (message) => {
  // Once we go to notify the marketplace, the label has either been created or errored
  return get(message, 'status.StatusID') === LABEL_SERVICE_BATCH_STATUS_IDS.NOTIFYING_MARKETPLACE;
};
